// import React from "react";

// const Drawer = ({ isOpen, onClose, customWidth = "w-[450px]", children }) => {
//     const isTailwindClass = typeof customWidth === "string";

//     return (
//         <>
//             {/* Backdrop */}
//             {isOpen && (
//                 <div
//                     className="fixed inset-0 bg-black bg-opacity-30 z-40"
//                     onClick={onClose}
//                 ></div>
//             )}

//             {/* Drawer */}
//             <div
//                 className={`fixed inset-y-0 right-0 bg-gray-50 shadow-xl z-40 transform transition-transform duration-300 ease-out ${
//                     isOpen ? "translate-x-0" : "translate-x-full"
//                 } ${isTailwindClass ? customWidth : ""}`} // Use Tailwind class if provided
//                 style={!isTailwindClass ? { width: customWidth } : {}} // Apply inline style if not a Tailwind class
//             >
//                 <div className="p-6 h-full overflow-y-auto">
//                     {/* Close Button */}
//                     <div className="flex justify-end mx-2">
//                         <button
//                             onClick={onClose}
//                             className="text-gray-500 hover:text-gray-800 text-lg"
//                         >
//                             ✖
//                         </button>
//                     </div>

//                     {/* Drawer Content */}
//                     <div className="mt-4">{children}</div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Drawer;

import React, { useEffect, useState } from "react";

const Drawer = ({
  isOpen,
  onClose,
  children,
  showClose = true,
  ChildParent = "px-4 py-2 h-full",
  ChilDiv = "mt-4",
  height_width = "md:h-full",
  border_radius = "rounded-md",
}) => {
  const [showDrawer, setShowDrawer] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowDrawer(true);
    } else {
      const timer = setTimeout(() => setShowDrawer(false), 300); // match transition
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // const isTailwindClass = typeof customWidth === "string";
  // const drawerWidthClass = isTailwindClass ? customWidth : "";

  return (
    <>
      {/* Backdrop */}
      {(isOpen || showDrawer) && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-[9990] backdrop-blur-sm"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      {(isOpen || showDrawer) && (
        <div
          className={`fixed z-[9995] md:w-[1190px] font-poppins rounded-t-3xl md:rounded-md h-[90%] dark:bg-gray-900 bg-white shadow-xl transform transition-transform duration-300 ease-in-out flex flex-col overflow-hidden
            bottom-0 left-0 right-0 ${
              isOpen ? "translate-y-0" : "translate-y-full"
            } md:top-1/2 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2`}
        >
          <div
            className={`${ChildParent} flex flex-col flex-1 min-h-0 overflow-hidden`}
          >
            <div className="flex justify-end flex-shrink-0">
              {showClose && (
                <button
                  onClick={onClose}
                  className="text-gray-500 dark:hover:text-gray-400 hover:text-gray-800 text-xl m-2"
                >
                  ✖
                </button>
              )}
            </div>
            <div className={`${ChilDiv} flex-1 overflow-y-auto`}>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Drawer;
